<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Earning from "./earning";
import TopSelling from "./top-selling.vue";
import { SimpleBar } from "simplebar-vue3";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { salesAnalyticsDonutChart, ChatData } from "./data";
import Loader from "../../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Atendimento",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    SimpleBar,
    Layout,
    PageHeader,
    Earning,
    TopSelling,
    Loader,
  },
  data() {
    return {
      updating: true,
      salesAnalyticsDonutChart: salesAnalyticsDonutChart,
      ChatData: ChatData,
      title: "Atendimento",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Atendimento",
          active: true,
        },
      ],
      submitted: false,
      chat: {
        message: "",
      },
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    chat: {
      message: {
        required: helpers.withMessage("Mensagem é obrigatório", required),
      },
    },
  },
  methods: {
    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        const id = this.ChatData.length;
        const message = this.chat.message;
        const currentDate = new Date();
        this.ChatData.push({
          id: id + 1,
          align: "right",
          name: "Usuário Testes 0099",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.chat = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  mounted() {
    console.log('mounted_dashAtendimento_1')


    // var container2 = document.querySelector(
    //   "#containerElement .simplebar-content-wrapper"
    // );
    // container2.scrollTo({ top: 500, behavior: "smooth" });

    api.get(`${getBaseUrl()}api/testarapiauth`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    })

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 110px;">
    </Loader>

      <div class="row" v-if="!updating">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <div class="d-flex">
                    <div class="me-3">
                      <img
                        src="@/assets/images/users/avatar-1.jpg"
                        alt
                        class="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div class="flex-grow-1 align-self-center">
                      <div class="text-muted">
                        <p class="mb-2">Bem vindo!</p>
                        <h5 class="mb-1">Maria da Silva</h5>
                        <p class="mb-0">Representante</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 align-self-center">
                  <div class="text-lg-center mt-4 mt-lg-0">
                    <div class="row">
                      <div class="col-4">
                        <div>
                          <p class="text-muted text-truncate mb-2">
                            Orçamentos Semana
                          </p>
                          <h5 class="mb-0">R$ 48.875,00</h5>
                        </div>
                      </div>
                      <div class="col-4">
                        <div>
                          <p class="text-muted text-truncate mb-2">Pedidos</p>
                          <h5 class="mb-0">R$ 400.587,00</h5>
                        </div>
                      </div>
                      <div class="col-4">
                        <div>
                          <p class="text-muted text-truncate mb-2">Clientes</p>
                          <h5 class="mb-0">780</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 d-none d-lg-block">
                  <div class="clearfix mt-4 mt-lg-0">
                    <b-dropdown
                      class="float-end"
                      right
                      variant="primary"
                      menu-class="dropdown-menu-end"
                    >
                      <template v-slot:button-content>
                        <i class="bx bxs-plus-circle align-middle me-1"></i> Atalhos
                      </template>
                      <b-dropdown-item @click="$router.push('/orcamentos/list')">Orçamentos</b-dropdown-item>
                      <b-dropdown-item @click="$router.push('/pedidos/list')">Pedidos</b-dropdown-item>
                      <b-dropdown-item @click="$router.push('/clientes/list')">Clientes</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <!-- end row -->
            </div>
          </div>
        </div>
      </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 150px;">
    </Loader>


      <div class="row" v-if="!updating">
        <div class="col-xl-4">
          <div class="card bg-soft bg-primary">
            <div>
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-3">
                    <h5 class="text-primary">Bem vindo!</h5>
                    <p>Dashboard de Atendimento</p>

                    <ul class="ps-3 mb-0">
                      <li class="py-1">+70 Novos clientes</li>
                      <li class="py-1">.15 Produtos promocionais</li>
                    </ul>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img
                    src="@/assets/images/profile-img.png"
                    alt
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8">
          <div class="row">
            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-copy-alt"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Em Elaboração</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>
                      R$ 1.452.000,00
                      <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                    </h4>
                    <div class="d-flex">
                      <span class="badge badge-soft-success font-size-12"
                        >+ 0.2%</span
                      >
                      <span class="ms-2 text-truncate">do período anterior</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-archive-in"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Confirmado</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>
                      R$ 280.870,52
                      <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                    </h4>
                    <div class="d-flex">
                      <span class="badge badge-soft-success font-size-12"
                        >+ 0.2%</span
                      >
                      <span class="ms-2 text-truncate">do período anterior</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-purchase-tag-alt"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Ticket Médio</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>
                      R$ 61.020,00
                      <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                    </h4>

                    <div class="d-flex">
                      <span class="badge badge-soft-warning font-size-12"
                        >0%</span
                      >
                      <span class="ms-2 text-truncate">do período anterior</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
      </div>


    <Loader class="mt-4" v-if="updating" style="min-height: 380px;">
    </Loader>


      <div class="row" v-if="!updating">
        <div class="col-xl-8">
          <Earning />
        </div>

        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Grupo de Produtos</h4>

              <div>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="240"
                  :series="salesAnalyticsDonutChart.series"
                  :options="salesAnalyticsDonutChart.chartOptions"
                ></apexchart>
              </div>

              <div class="text-center text-muted">
                <div class="row">
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-primary me-1"></i>
                        Grupo 001
                      </p>
                      <h5>R$ 2.132,00</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-success me-1"></i>
                        Grupo 002
                      </p>
                      <h5>R$ 1.763,00</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-danger me-1"></i>
                        Grupo 003
                      </p>
                      <h5>R$ 973,00</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    <Loader class="mt-4" v-if="updating" style="min-height: 100px;">
    </Loader>

      <div class="row" v-if="!updating">
        <div class="col-xl-4">
          <TopSelling />
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Notificações</h4>

              <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
                <b-tab title="Faturamento" active>
                  <b-card-text>
                    <SimpleBar style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 50px">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckNotifi01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckNotifi01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Pedido 09988 Faturado - R$ 57.980,00
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">20/03/2023</p>
                              </td>
                              <td style="width: 90px">
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckNotif02"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckNotif02"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark"
                                    >Novo Orçamento - R$ 41.200,00</a
                                  >
                                </h5>
                                <p class="text-muted mb-0">20/03/2023</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckOrcto01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckOrcto01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Pedido 055768 Faturado - 98.555,20
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">19/03/2023</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>



                          </tbody>
                        </table>
                      </div>
                    </SimpleBar>
                  </b-card-text>
                </b-tab>
                <b-tab title="Clientes">
                  <b-card-text>
                    <SimpleBar style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 50px">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckCli01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckCli01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Novo - Cliente Testes 099
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">18/03/2023</p>
                              </td>
                              <td style="width: 90px">
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckCli02"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckCli02"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark"
                                    >Novo - Cliente Testes 888</a
                                  >
                                </h5>
                                <p class="text-muted mb-0">19/03/2023</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheckCli03"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheckCli03"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Novo - Cliente Testes 002
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">15/03/2023</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>





                          </tbody>
                        </table>
                      </div>
                    </SimpleBar>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </div>

            <div class="card-footer bg-transparent border-top">
              <div class="text-center">
                <router-link to="/notificacoes/list" class="btn btn-primary">
                  Mais detalhes
                </router-link>
              </div>
            </div>
          </div>
        </div>


        <div class="col-xl-4">
          <div class="card">
            <div class="card-body border-bottom">
              <div class="row">
                <div class="col-md-4 col-9">
                  <h5 class="font-size-15 mb-1">Últimos Alertas</h5>
                  <p class="text-muted mb-0">
                    <i class="mdi mdi-circle text-success align-middle me-1"></i>
                    38 minutos
                  </p>
                </div>
                <div class="col-md-8 col-3">
                  <ul class="list-inline user-chat-nav text-end mb-0">



                    <li class="list-inline-item">
                      <b-dropdown
                        toggle-class="nav-btn"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                      >
                        <template v-slot:button-content>
                          <i class="bx bx-dots-horizontal-rounded"></i>
                        </template>
                        <b-dropdown-item>Mais detalhes</b-dropdown-item>

                      </b-dropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-body pb-0">
              <div>
                <div class="chat-conversation">
                  <ul class="list-unstyled">
                    <SimpleBar
                      style="max-height: 260px"
                      ref="current"
                      id="containerElement"
                    >

                      <li
                        v-for="data of ChatData"
                        :key="data.id"
                        :class="{ right: `${data.align}` === 'right' }"
                      >
                        <div class="conversation-list">

                          <div class="ctext-wrap">
                            <div class="conversation-name">{{ data.name }}</div>
                            <p>{{ data.message }}</p>
                            <p class="chat-time mb-0">
                              <i class="bx bx-time-five align-middle me-1"></i>
                              {{ data.time }}
                            </p>
                          </div>
                        </div>
                      </li>
                    </SimpleBar>
                  </ul>
                </div>
              </div>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                      id="inputChatMesDash02"
                      type="text"
                      v-model="chat.message"
                      class="form-control chat-input"
                      placeholder="Novo alerta..."
                      :class="{
                        'is-invalid': submitted && v$.chat.message.$error,
                      }"
                    />
                    <div
                    v-if="submitted && v$.chat.message.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="v$.chat.message.required.$message">{{
                      v$.chat.message.required.$message
                    }}</span>
                    </div>

                  </div>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary chat-send w-md">
                    <span class="d-none d-sm-inline-block me-2">Enviar</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

  </Layout>
</template>
